import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class LoaderAPI extends ComponentAPI {
    isCentered() {
        return this.state.centered;
    }
    setCentered(centered) {
        this.setState({ centered });
    }
    getColor() {
        return this.state.color;
    }
    setColor(color) {
        this.setState({ color });
    }
    getMessage() {
        return this.state.message;
    }
    setMessage(message) {
        this.setState({ message });
    }
    getMessageDelay() {
        return this.state.messageDelay;
    }
    setMessageDelay(messageDelay) {
        this.setState({ messageDelay });
    }
    getShowMessage() {
        return this.state.showMessage;
    }
    setShowMessage(showMessage) {
        this.setState({ showMessage });
    }
    getSize() {
        return this.state.size;
    }
    setSize(size) {
        this.setState({ size });
    }
}
export default LoaderAPI;
//# sourceMappingURL=loader-api.js.map